var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebookWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-facebook-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1002",
    transform: "translate(.204 .367)",
    fill: "#fff",
    d: "M0 0h10v18H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Facebook"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2113",
    clipPath: "url(#icon-facebook-white_svg__a)",
    transform: "translate(-.204 -.367)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5417",
    d: "M10.408 3.257H7.435c-.351 0-.744.463-.744 1.081v2.147h3.717v3.06H6.691v9.19H3.182v-9.19H0v-3.06h3.182v-1.8A4.415 4.415 0 017.435-.001h2.973z",
    fill: "#fff"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDEwIDE4Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iYSI+CiAgICAgIDxyZWN0IGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDEwMDIiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjIwNCAuMzY3KSIgZmlsbD0iI2ZmZiIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGcgZGF0YS1uYW1lPSJJY29uIC0gRmFjZWJvb2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uMjA0IC0uMzY3KSI+CiAgICA8ZyBkYXRhLW5hbWU9Ikdyb3VwIDIxMTMiIGNsaXAtcGF0aD0idXJsKCNhKSI+CiAgICAgIDxwYXRoIGRhdGEtbmFtZT0iUGF0aCA1NDE3IiBkPSJNMTAuNDA4IDMuMjU3SDcuNDM1Yy0uMzUxIDAtLjc0NC40NjMtLjc0NCAxLjA4MXYyLjE0N2gzLjcxN3YzLjA2SDYuNjkxdjkuMTlIMy4xODJ2LTkuMTlIMHYtMy4wNmgzLjE4MnYtMS44QTQuNDE1IDQuNDE1IDAgMCAxIDcuNDM1LS4wMDFoMi45NzNaIiBmaWxsPSIjZmZmIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { SvgIconFacebookWhite as ReactComponent };